// contrast — per-pixel midtone S-curve. ((c - 128) * 1.32) + 128, clamped.
// Boosts midtone contrast ~32% (bumped 1.15 → 1.22 → 1.32 over iterations —
// F-wave β user feedback was "cool Polaroid feel", which wants a steeper S so
// shadows really sink and highlights pop alongside coolCast + bloom).
//
// 128 stays the fixed point; clamping prevents overflow at the extremes.

import { type FilterContext, eachPixel, getImageData, putImageData } from './_helpers'

const FACTOR = 1.32

export function contrast(c: FilterContext): void {
  const img = getImageData(c.ctx)
  eachPixel(img, (r, g, b, a) => [
    (r - 128) * FACTOR + 128,
    (g - 128) * FACTOR + 128,
    (b - 128) * FACTOR + 128,
    a,
  ])
  putImageData(c.ctx, img)
}
